<!-- commented out code removed -->
<nav class="breadcrumb-container">
  <ul class="breadcrumb-list">
    <li
      *ngFor="let breadcrumb of breadcrumbs; let last = last"
      class="breadcrumb-item"
      [class.active]="last"
    >
      <a
        *ngIf="!last"
        [routerLink]="breadcrumb.url"
      >
        {{
          (breadcrumb.label.startsWith("breadcrumb.")
            ? breadcrumb.label
            : "breadcrumb." + (breadcrumb.label | formatBreadcrumbLabel)
          ) | translate
        }}
      </a>

      <span *ngIf="last">
        {{
          (breadcrumb.label.startsWith("breadcrumb.")
            ? breadcrumb.label
            : "breadcrumb." + (breadcrumb.label | formatBreadcrumbLabel)
          ) | translate
        }}
      </span>
    </li>
  </ul>
</nav>
